import { Modal, Grid, Button, Input } from '@design-systems/canvas-ui'
import Icon, { ThumbsUpIcon } from '@design-systems/react-icons'
import { getRfiTagValues } from '../../../common/common'
import {
  RFI_TYPE_LOCATION,
  STATUS_APPROVED,
  STATUS_COMPLETE_REVIEW,
  STATUS_LIST_WITHOUT_COMMENTS,
  STATUS_REJECTED,
  STATUS_SENT_BACK,
  STATUS_APPROVE_BUT_HOLD,
  STATUS_APPROVE_AND_BYPASS_VFA,
  STATUS_APPROVE_AND_START_VFA,
  STATUS_RFI3_APPROVED,
  MANUFACTURING_TYPE_ID_PACKAGING,
} from '../../../common/commonConstants'

const headerTextMapper = {
  [STATUS_COMPLETE_REVIEW.toLowerCase()]:
    'Profile about to be Review Completed',
  [STATUS_APPROVED.toLowerCase()]: 'Profile about to be Approved',
  [STATUS_RFI3_APPROVED.toLowerCase()]: 'Profile about to be Approved',
  [STATUS_REJECTED.toLowerCase()]: 'Profile about to be Rejected',
  [STATUS_SENT_BACK.toLowerCase()]: 'Profile about to be Sent Back',
  [STATUS_APPROVE_BUT_HOLD.toLowerCase()]:
    'Profile about to be Approved but hold',
  [STATUS_APPROVE_AND_BYPASS_VFA.toLowerCase()]:
    'Profile about to be Approved & bypass VFA',
  [STATUS_APPROVE_AND_START_VFA.toLowerCase()]:
    'Profile about to be Approved & start VFA',
}

const RfiFormApprovalConfirmationModal = (props) => {
  /**
   * Get heading text label for modal
   */
  const getHeadingTextForModal = () => {
    const rfiTypeCapitalised =
      props.rfiType?.charAt(0)?.toUpperCase() + props.rfiType?.slice(1)
    return `${rfiTypeCapitalised} ${
      headerTextMapper[props.userAction?.toLowerCase()]
    }!`
  }

  /**
   * Get confirmation message header
   */
  const getConfirmationMessageHeader = () => {
    let confirmationMessage = ''
    switch (props.userAction?.toLowerCase()) {
      case STATUS_COMPLETE_REVIEW.toLowerCase():
        if (props.rfiType?.toLowerCase() === RFI_TYPE_LOCATION) {
          confirmationMessage =
            getRfiTagValues('headingMessages')[
              'rfiLocationActionCompleteReviewMessage'
            ]
        }
        break
      case STATUS_APPROVED.toLowerCase():
        confirmationMessage =
          getRfiTagValues('headingMessages')[
            props.rfiType?.toLowerCase() === RFI_TYPE_LOCATION
              ? 'rfiLocationActionApprovalMessage'
              : 'rfiSupplierActionApprovalMessage'
          ]
        break
      case STATUS_REJECTED:
        confirmationMessage =
          getRfiTagValues('headingMessages')[
            props.rfiType?.toLowerCase() === RFI_TYPE_LOCATION
              ? 'rfiLocationActionRejectMessage'
              : 'rfiSupplierActionRejectMessage'
          ]
        break
      case STATUS_SENT_BACK.toLowerCase():
        confirmationMessage =
          getRfiTagValues('headingMessages')[
            props.rfiType?.toLowerCase() === RFI_TYPE_LOCATION
              ? 'rfiLocationActionSentBackMessage'
              : 'rfiSupplierActionSentBackMessage'
          ]
        break
      case STATUS_APPROVE_BUT_HOLD.toLowerCase():
        confirmationMessage =
          getRfiTagValues('headingMessages')[
            'rfiQuestionnaireApproveButHoldMessage'
          ]
        break
      case STATUS_APPROVE_AND_BYPASS_VFA.toLowerCase():
        confirmationMessage =
          getRfiTagValues('headingMessages')[
            'rfiQuestionnaireApproveAndBypassVFAMessage'
          ]
        break
      case STATUS_APPROVE_AND_START_VFA.toLowerCase():
        confirmationMessage =
          getRfiTagValues('headingMessages')[
            'rfiQuestionnaireApproveAndStartVFAMessage'
          ]
        break
      case STATUS_RFI3_APPROVED.toLowerCase():
        confirmationMessage =
          getRfiTagValues('headingMessages')['rfiQuestionnaireApproveMessage']
        break
      default:
        break
    }
    return confirmationMessage
  }

  const isRfiActionYesButtonDisabled = () => {
    return (
      props.userAction?.toUpperCase() !== STATUS_APPROVED.toUpperCase() &&
      props.userAction?.toUpperCase() !==
        STATUS_COMPLETE_REVIEW.toUpperCase() &&
      props.userAction?.toUpperCase() !==
        STATUS_APPROVE_AND_START_VFA.toUpperCase() &&
      !props.userComments?.trim().length
    )
  }

  const isBlockCommentsCapture = () => {
    return (
      STATUS_LIST_WITHOUT_COMMENTS.includes(props.userAction?.toUpperCase()) ||
      (props.manufacturingTypeId?.toString() ===
        MANUFACTURING_TYPE_ID_PACKAGING &&
        props.userAction?.toUpperCase() === STATUS_RFI3_APPROVED)
    )
  }

  return (
    <Modal
      id="modal-vetting-action"
      headingText={getHeadingTextForModal()}
      size="sm"
      isOpen={props.isVisible}
      onClose={() => {
        props.closeRFIActionConfirmationModal()
      }}
      className="lcm-rfi-approval-confirm-modal"
    >
      <Grid.Container className="lcm-rfi-approval-confirm__content hc8-ph-6x hc8-pt-4x hc8-pb-4x">
        {(props.userAction?.toLowerCase() === STATUS_APPROVED ||
          (props.userAction?.toUpperCase() === STATUS_RFI3_APPROVED &&
            props.manufacturingTypeId?.toString() ===
              MANUFACTURING_TYPE_ID_PACKAGING)) && (
          <Grid.Item size={{ xs: 12 }} className="hc8-ta-center">
            <Icon
              svg={ThumbsUpIcon}
              size="xl"
              className="hc8-clr-brand"
              aria-hidden
            />
          </Grid.Item>
        )}
        <Grid.Item
          size={{ xs: 12 }}
          className="lcm-rfi-approval-confirm__message hc8-clr-placeholder hc8-fs-100 hc8-pl-none hc8-pt-none hc8-lh-body"
        >
          {' '}
          {getConfirmationMessageHeader()}
        </Grid.Item>

        {!isBlockCommentsCapture() && (
          <Grid.Item
            size={{ xs: 12 }}
            className="lcm-rfi-approval-confirm__comment hc8-pl-none hc8-pr-none"
          >
            <Input.Label className="hc8-fs-100">
              Provide Additional Comment
            </Input.Label>
            <Input.Textarea
              data-testid="textarea-send-back-comment"
              id="textarea-send-back-comment"
              value={props.userComments}
              placeholder="Comments"
              onChange={(event) => {
                props.setUserCommentsValue(event)
              }}
              isErrored={
                !props.userComments ||
                props.userComments?.length === 0 ||
                props.userComments?.length >= props.commentsMaxLen
              }
              errorText="Please enter a value within 500 characters"
            />
            <Input.Label className="lcm-modal-comment-counter hc8-clr-placeholder hc8-fs-150 hc8-mt-2x">{`${props.userComments ? props.userComments?.length : 0} / ${props.commentsMaxLen}`}</Input.Label>
          </Grid.Item>
        )}

        <Grid.Item
          size={{ xs: 12 }}
          className="lcm-modal-actions hc8-pt-4x hc8-pb-2x"
        >
          <Button
            variant="secondary"
            size="md"
            className="hc8-mr-3x"
            onClick={() => {
              props.closeRFIActionConfirmationModal()
            }}
            data-testid="no-button"
          >
            No
          </Button>
          <Button
            variant="primary"
            size="md"
            onClick={() => {
              if (props.onSaveCtpData) {
                props.onSaveCtpData()
              }
              props.onActionConfirmation(true)
            }}
            isDisabled={isRfiActionYesButtonDisabled()}
            data-testid="yes-button"
          >
            Yes
          </Button>
        </Grid.Item>
      </Grid.Container>
    </Modal>
  )
}

export default RfiFormApprovalConfirmationModal
